import React, { useEffect } from 'react';
import NotifyIcon from '../../assets/images/notifiyIcon.svg';
import WorkIcon from '../../assets/images/workIcon.svg';
import EmployeeList from './EmployeeList';
import { SlDoc } from 'react-icons/sl';
import UpcomingEvents from './UpcomingEvents';
import LeaveRegularise from './LeaveRegularise';
import { FaRegCalendarAlt, FaUserClock, FaUsers } from 'react-icons/fa';
import { useLazyGetPeopleDataQuery } from '../../features/apis/authApi';
import { RiFeedbackLine } from 'react-icons/ri';
import DashboardCardSkeleton from '../../components/Skeletons/DashboardCardSkeleton';
import TableSkeleton from '../../components/Skeletons/TableSkeleton';
import CardSkeleton from '../../components/Skeletons/CardSkeleton';
function AdminDashbaord() {
  const [getPeopleData, { data, isLoading }] = useLazyGetPeopleDataQuery();
  useEffect(() => {
    getPeopleData();
  }, [getPeopleData]);

  if (isLoading) {
    return (
      <div className=" space-y-4 font-inter">
        <DashboardCardSkeleton />
        <div className="flex p-6 flex-col md:flex-row justify-between w-full gap-4 h-full ">
          <div className="w-full md:w-3/4 flex-grow bg-white rounded-md shadow-md p-4">
            <div className="h-5 w-32 bg-gray-200 rounded mb-4 animate-pulse" />
            <TableSkeleton
              columns={[
                { type: 'text', width: '40px' },
                { type: 'avatar', width: '200px' },
                { type: 'text', width: '120px' },
                { type: 'text', width: '100px' },
                { type: 'text', width: '100px' },
                { type: 'badge', width: '120px' },
              ]}
              rows={5}
              className="border-none"
            />
          </div>
          <div className="w-full md:w-1/4 flex-grow bg-white rounded-md shadow-md p-6">
            <div className="h-5 w-32 bg-gray-200 rounded mb-4 animate-pulse" />
            <div className="space-y-3">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse shrink-0" />
                  <div className="flex-1 space-y-2">
                    <div className="h-3 w-20 bg-gray-200 rounded animate-pulse" />
                    <div className="h-2 w-16 bg-gray-100 rounded animate-pulse" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="bg-white rounded-md shadow-lg p-6">
          <div className="h-5 w-40 bg-gray-200 rounded mb-4 animate-pulse" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[...Array(4)].map((_, i) => (
              <CardSkeleton key={i} lines={2} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-4 font-inter">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        <div className="bg-[linear-gradient(to_right,_#6E3EF5,_#B398FF)] flex justify-between items-center py-4 px-6 rounded-md gap-6 text-white">
          <div className="flex flex-col ">
            <h1 className="text-3xl ">{data?.data?.totalPresentEmployees} </h1>
            <p className="text-[10px]">Present Employees Today</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <FaRegCalendarAlt color="#6E3EF5" size={18} />
            </div>
            <p className="text-[10px] mt-2">
              {data?.data?.leaveRequests?.groupedByType?.General} Casual
            </p>
            <p className="text-[10px]">
              {' '}
              {data?.data?.leaveRequests?.groupedByType?.Birthday} Birthday
            </p>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393]">
              {data?.data?.totalMonthlyTimeInHours
                ? data?.data?.totalMonthlyTimeInHours?.toFixed(0)
                : '0'}{' '}
            </h1>

            <p className="text-[10px]">Monthly Collective Hours </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <img src={WorkIcon} className="h-8 w-8" />
            </div>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">03 </h1>
            <p className="text-[10px]">Holidays this Month </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <FaRegCalendarAlt color="#6E3EF5" size={30} />
            </div>
            <p className="text-[10px] mt-2">02 Diwali Festival </p>
            <p className="text-[10px]"> 04 Gowardhan </p>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">
              {data?.data?.leaveRequests?.totalPending}{' '}
            </h1>
            <p className="text-[10px] ">Leave Requests </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <FaUserClock color="#6E3EF5" size={32} />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-stretch">
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6 ">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">
              {' '}
              {data?.data?.totalDocuments}{' '}
            </h1>
            <p className="text-[10px]">Company Documents</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <SlDoc color="#6E3EF5" size={30} />
            </div>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">
              {data?.data?.regulariseRequests?.totalPending}
            </h1>
            <p className="text-[10px]">Grievances This Month</p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <RiFeedbackLine color="#6E3EF5" size={32} />
            </div>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">
              {' '}
              {data?.data?.totalEmployees}{' '}
            </h1>
            <p className="text-[10px]">Total Employees </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <FaUsers color="#6E3EF5" size={30} />
            </div>
            <p className="text-[10px] mt-2">
              {' '}
              {data?.data?.employeeTypes?.fullTime} Regular Employee
            </p>
            <p className="text-[10px]">
              {' '}
              {data?.data?.employeeTypes?.interns} Interns{' '}
            </p>
          </div>
        </div>
        <div className="bg-white flex justify-between items-center py-4 px-6 rounded-md gap-6">
          <div className="flex flex-col ">
            <h1 className="text-5xl text-[#939393] ">
              {' '}
              {data?.data?.totalRequest}{' '}
            </h1>
            <p className="text-[10px]">Notifications Received </p>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-full flex justify-center items-center">
              <img src={NotifyIcon} className="h-8 w-8" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between w-full gap-4 h-full ">
        <div className="w-full md:w-3/4 flex-grow ">
          <EmployeeList />
        </div>
        <div className="w-full md:w-1/4 flex-grow">
          <UpcomingEvents />
        </div>
      </div>
      <LeaveRegularise />
    </div>
  );
}

export default AdminDashbaord;
